import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { toast } from "react-toastify";
import API from "../../api/axios";
import { APP_URLS } from "../../api/url";
import { FAQWrapper } from "./style/faqWrapper";
import { APIError, extractPlainTextFromHTML } from "../../core/utils";
import { FAQ_TYPE_INVERSE } from "../../config/constant";

const CreateEventFAQs = () => {
  const parsedLanguages = JSON.parse(localStorage.getItem("languages") || "[]");
  const parsedCountries = JSON.parse(localStorage.getItem("countries") || "[]");

  const typeRef = useRef(null);

  const [question, _question] = useState({ en: "", fr: "" });
  const [answer, _answer] = useState({ en: "", fr: "" });
  const [type, _type] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (val, code, state) => {
    state((prevState) => {
      return { ...prevState, [code]: val };
    });
  };

  const isEmpty = (value) => {
    return !value || value.trim() === "";
  };

  const submitForm = () => {
    if (loading) return;
    const enAnswer = extractPlainTextFromHTML(answer["en"]);
    const frAnswer = extractPlainTextFromHTML(answer["fr"]);

    const enQuestion = question["en"];
    const frQuestion = question["fr"];

    const showError = (msg) =>
      toast.error(msg, { position: toast.POSITION.TOP_RIGHT });

    if (
      (isEmpty(enQuestion) || isEmpty(enAnswer)) &&
      (isEmpty(frQuestion) || isEmpty(frAnswer))
    ) {
      return showError(
        "Question and Answer both in English and French are mandatory"
      );
    }

    if (isEmpty(enQuestion) || isEmpty(enAnswer)) {
      return showError("Question and Answer both in English are mandatory");
    }

    if (isEmpty(frQuestion) || isEmpty(frAnswer)) {
      return showError("Question and Answer both in French are mandatory");
    }

    if (isEmpty(type)) {
      typeRef.current?.focus();
      return showError("Choose FAQ Type");
    }

    let hasValidationError = false;

    Object.keys(question).forEach((lang) => {
      const qText = question[lang];
      const aText = extractPlainTextFromHTML(answer[lang]);

      if (qText.length > 250) {
        hasValidationError = true;
        showError(
          `Question for ${
            parsedLanguages.find((o) => o.code === lang)?.name
          } should not exceed 250 characters.`
        );
      }

      if (!isEmpty(qText) && isEmpty(aText)) {
        hasValidationError = true;
        showError(
          `Add answer for ${parsedLanguages.find((o) => o.code === lang)?.name}`
        );
      }

      if (!isEmpty(aText) && isEmpty(qText)) {
        hasValidationError = true;
        showError(
          `Add question for ${
            parsedLanguages.find((o) => o.code === lang)?.name
          }`
        );
      }
    });

    if (hasValidationError) return;

    const data = {
      question: question,
      answer: {},
      app_type: 2,
      faq_type: type,
    };

    Object.keys(answer).forEach((lang) => {
      data.answer[lang] = draftToHtml(
        convertToRaw(answer[lang].getCurrentContent())
      );
    });

    setLoading(true);
    API.post(APP_URLS.ADD_FAQS, data)
      .then((res) => {
        const resp = res.data;
        if (resp.success) {
          toast.success("FAQ Added Successfully.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/faqs");
        } else {
          showError(resp.message);
        }
      })
      .catch((error) => {
        showError(APIError(error));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <FAQWrapper>
      <div className="mt-2">
        <div className="backContainer ms-4" onClick={() => navigate("/faqs")}>
          <span className="backButton">x</span>
          <span className="px-3 backButton">|</span>
          <span className="backButton">Cancel</span>
        </div>
      </div>
      <div className="headerContainer">
        <h1>CREATE FAQ FOR ADS AND DEPOSITS</h1>
      </div>
      <div className="d-flex justify-content-end save-btn mt-3">
        <button className="add-button" onClick={submitForm} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
      <div className="row">
        <div className="col-md-4 offset-md-2">
          <label
            htmlFor="startDate"
            className="form-label product-type fieldLabel"
          >
            FAQ Type
          </label>
          <select
            name="productType"
            id="productType"
            className="form-control mt-2 mb-4"
            value={type}
            ref={typeRef}
            onChange={(e) => _type(e.target.value)}
          >
            <option hidden>Select FAQ Type</option>
            {Object.keys(FAQ_TYPE_INVERSE).map((faqType) => {
              return FAQ_TYPE_INVERSE[faqType] !== FAQ_TYPE_INVERSE.Standard ? (
                <option value={FAQ_TYPE_INVERSE[faqType]}>{faqType}</option>
              ) : null;
            })}
          </select>
        </div>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-md-8">
          {parsedLanguages.map((item, index) => {
            let itemCode = item.code;
            let flag = parsedCountries.find(
              (o) => o.id === item.country_id
            )?.flag_thumbnail;
            return (
              <div className="mb-5" key={index}>
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label">
                    <img
                      src={flag}
                      alt={item.name}
                      title={item.name}
                      className="countryflag mx-2"
                      loading="lazy"
                    />
                    <span className="langName fieldLabel ">Question</span>
                  </label>
                  <textarea
                    className="form-control langaugeFields mb-2"
                    id="language"
                    rows="2"
                    onChange={(e, code = itemCode) => {
                      handleChange(e.target.value, code, _question);
                    }}
                  ></textarea>
                </div>
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label">
                    <span className="langName fieldLabel ms-2">Answer</span>
                  </label>
                  <Editor
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor answer"
                    localization={{
                      locale: itemCode,
                    }}
                    editorState={answer[itemCode]}
                    onEditorStateChange={(e, code = itemCode) => {
                      handleChange(e, code, _answer);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </FAQWrapper>
  );
};

export default CreateEventFAQs;
